import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import {makeStyles, useTheme, ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import { Tabs, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextInput from '../../components/TextField'
import { green, purple } from '@material-ui/core/colors';
import Joi from '@hapi/joi'
import { useForm } from 'react-final-form-hooks'
import moment from 'moment'
import useLoading from '../../components/loading/hook'
import httpp from '../../service/http'
import validate from '../../service/form/validation'
import formCreateInputs from '../../service/form/create'
import {Web3, web3} from 'Backend/Web3'

import ABI from "./ABI";
import Trc721ABI from "./Trc721ABI";
import Checkbox from '../../components/checkbox'
const DEFAULT_FROM_DATE = moment().format('YYYY-MM-DDTHH:mm')
const DEFAULT_TO_DATE = moment().add(1, 'd').format('YYYY-MM-DDTHH:mm')

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    roottomo: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});
function retryGetLink (config, hash, maxRepeat = 50, repeat = 0, delay = 2000) {
    console.log('repeat', repeat)
    const http = httpp(config);
    return http.get({
        path: 'proxy-api',
        params: {url: config.exploreUrl + 'api/txs/' + hash}
    }).then(r => {
        if (r.status !== undefined) return r;
        if (repeat < maxRepeat) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return r;
    }).catch(() => {
        // console.log('error')
        if (repeat < maxRepeat) {
            // recall if api error
            return new Promise((resolve) => {
                setTimeout(() => {
                    return resolve(retryGetLink(config, hash, maxRepeat, ++repeat, delay || 1500));
                }, delay || 1500);
            });
        }
        return null;
    });
}
export default function Tomo({config, userAuth, setTableRows, withLoading, setPageM}) {
    const http = httpp(config)
    const classes = useStyles();
    const account = userAuth.address
    const [initialInputs, updateInitialInputs] = useState({})
    const [isPass, setIsPass] = useState(false)
    const [error, setError] = useState('')
    const checkApprove =  (params) => {
        return new Promise((resolve) => {
            const contractAddress = params.tokenAddress
            try {
                const contract = web3.eth.contract(Trc721ABI).at(contractAddress)
                if (contract.isApprovedForAll) {
                    contract.isApprovedForAll(account, config.contractReceiveLink, (err, res) => {
                        // console.log(err, res)
                        if(err) {
                        resolve(false)
                       } else {
                           resolve(res)
                       }
                    })
                } else resolve(false)
            } catch (e) {
                resolve(false)
            }
        })

    }
    const checkOwner = (contractAddress, tokenIds) => {
        return new Promise(async (resolve, reject) => {
            const all = tokenIds.map(tokenId => {
                return new Promise((resolve) => {
                    const contract = web3.eth.contract(Trc721ABI).at(contractAddress)
                    if (contract.ownerOf) {
                        contract.ownerOf(tokenId, (err, res) => {
                            if (err){
                                resolve(err)
                            } else {
                                resolve({tokenId, owner: res})
                            }
                        })
                    } else {
                        // console.log('Invalid function ownerOf this token');
                        resolve(false)
                    }
                })
            })
             Promise.all(all).then(arr => {
                 console.log('postBaseSendTxs - Final send result', arr)
                 resolve(arr)
            }).catch(err => {
                console.log('eeee' + err)
                reject(err)
            })
        })


    }
    const Approve = async (params) => {

        const contract = web3.eth.contract(Trc721ABI).at(params.tokenAddress);
        // console.log(params.num, ids, amount)

        const dataTx = contract.setApprovalForAll.getData(config.contractReceiveLink, true);

        const rawTx = {
            from: account,
            to: params.tokenAddress,
            data:dataTx,
            gasPrice: 1000000000,
            gasLimit: 1000000000,
        }
        return new Promise((resolve, reject) => {
            web3.eth.sendTransaction(rawTx, (err, res) => {
                if (!err) {
                    resolve(res)
                } else {
                    reject(err)
                }
            })
        })
    }
    const createLink = async (params1, arrTokenIds) => {
        return new Promise((resolve, reject) => {
            const params = {...params1}
            params.password = isPass ? params1.password : config.defaultPassword
            params.fromDate = moment(params.fromDate).unix()
            params.toDate = moment(params.toDate).unix()
            const contractAddress = config.contractReceiveLink
            const contract = web3.eth.contract(ABI).at(contractAddress);
            const ids = []
            const slugs = [];
            for (let i = 0; i < arrTokenIds.length; i++) {
                ids.push(Math.floor(Math.random() * (9999999999999999999 - 1000000000000000000 + 1)) + 1000000000000000000)
                // generate slug
                let slug = ''
                const possible = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'
                for (let i = 0; i < 16; i++) {
                    slug += possible.charAt(Math.floor(Math.random() * possible.length))
                }
                slugs.push(slug);
            }

            const dataTx = contract.sendTRC721s.getData(ids, params.tokenAddress, arrTokenIds, params.fromDate, params.toDate);
            // console.log(ids, params.tokenAddress, arrTokenIds, moment(params.fromDate).unix(),
            //     moment(params.toDate).unix(), params.password)
            const rawTx = {
                to: contractAddress,
                data: dataTx,
                from: account,
                gasPrice: 1000000000,
                gasLimit: 1000000000000,
            }
            web3.eth.sendTransaction(rawTx, (err, res) => {
                if (!err) {
                    console.log(res)
                    setTimeout(() => {
                        retryGetLink(config, res).then((rs) => {
                            if (rs) {
                                console.log(rs)
                                if (rs.status == true) {
                                    const records = []
                                    ids.map((id, i) => {
                                        const params1 = {...params}
                                        params1.amount = arrTokenIds[i]
                                        params1.link = config.receiveLink + slugs[i]
                                        params1.tokenId = arrTokenIds[i]
                                        records.push({
                                            userAddress: account,
                                            hash: res,
                                            code: id.toString(),
                                            slug: slugs[i],
                                            type: 'trc721',
                                            metaData: params1,
                                            isPassword: isPass
                                        })
                                    })
                                    return http.post({
                                        path: 'receive-link',
                                        payload: records
                                    }).then(() => {
                                        setPageM(0)
                                        resolve(rs)
                                    }).catch(err => {
                                        console.log('sendTRC721s - error: ', err)
                                        reject(err)
                                    });
                                } else reject(rs)
                            }
                        }).catch(err => {
                            console.log('sendTRC721s - error: ', err)
                            reject(err)
                        })
                    }, 5000)

                } else {
                    console.error(err);
                    reject(err)
                }

            })
        })
    }
    const onSubmit = async (params) => {
        const tokenIds = params.tokenIds.trim().split(',').map(t => Number(t))
        const isApprove =  await checkApprove(params)

        let data = await checkOwner(params.tokenAddress, tokenIds)
        // console.log('data',data)

        console.log('tokenIds', isApprove, tokenIds, data)
        let errMsg = ''
        data.filter(x => x.owner.toLowerCase() != account.toLowerCase()).map((da, i) => {
            errMsg += 'not owner of ' + da.tokenId + ', '
        })
        if(errMsg != '') setError(errMsg)
        if(!isApprove) {
            const rs = await Approve(params)
                console.log(rs)

                setTimeout(withLoading(() => createLink(params, tokenIds), 2000))
        }  else withLoading(() => createLink(params, tokenIds))

    }
    const schema = Joi.object().keys({
        tokenAddress: Joi.string().required(),
        // num: Joi.number().required(),
        tokenIds: Joi.string().required(),
        fromDate: Joi.date().required(),
        toDate: Joi.date().required(),
        password: Joi.string().max(4).allow(null),
    })
    const { form, handleSubmit } = useForm({
        onSubmit,
        validate: validate(schema),
        initialValues: initialInputs
    })
    const [tokenAddress, tokenIds, fromDate, toDate, password] = formCreateInputs(['tokenAddress', 'tokenIds', 'fromDate', 'toDate', 'password'], form)
    useEffect(() => {
        if(!initialInputs.num) updateInitialInputs({
            tokenAddress:  config.env !== 'production' ? '0x87c107b91c2df1be243e4b82d7b0705c2adcc7a2' : '',
            // num: 1,
            fromDate: DEFAULT_FROM_DATE,
            toDate: DEFAULT_TO_DATE,
            // password: '123123Aa',
        })
        setPageM(0)
    //     userAuth.address && withLoading(() => http.get({ path: 'receive-link/' + userAuth.address, params: {type: 'trc721'} }).then(rs => {
    //         rs.data = rs.data.map(r => {
    //             r.amount = r.metaData.amount || r.metaData.tokenIds
    //             r.fromDate = r.metaData.fromDate
    //             r.toDate = r.metaData.toDate
    //             return r
    //         })
    //         setTableRows(rs)
    //     }))
    }, [initialInputs.num])
    const handleChangeIsPass = (status) => {
        setIsPass(status)
        // console.log(status, isPass)
    }
    return (
        <form onSubmit={handleSubmit} className={classes.roottomo} noValidate autoComplete="off">
            <div>
                <TextInput style={{width: 400}} input={tokenAddress} label="Trc721" />
                {/*<TextInput input={num} label="Num of link" />*/}
                <TextInput input={tokenIds} label="Token Ids" multiline={true} style={{width: 400}}
                helperText={'In case you want to deposit multi NFT, please input as this format: "ID1,ID2,ID3,..."'}/>
                <TextInput style={{marginLeft: 15, width: 200}} input={fromDate} label='Start Time' type='datetime-local' InputLabelProps={{
                    shrink: true,
                }}/>

                <TextInput
                    input={toDate}
                    id="datetime-local"
                    label="End Time"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Checkbox checked={isPass} label={'Is Password'} handleChangeIsPass={handleChangeIsPass}/>

                {isPass && <TextInput
                    input={password}
                    id="standard-helperText"
                    label="Password"
                    type="number"
                    helperText="Receiver need this info to get, Please input exactly 4 numbers only!"
                />}
            </div>

            <ThemeProvider theme={theme}>
                <Button type='submit' variant="contained" color="primary" className={`btn ${classes.margin}`}>
                    Submit
                </Button>
            </ThemeProvider>
            <div style={{ color: '#f50057' }}>{error}</div>
        </form>
    );
}
